import {Data} from './data';
import {Partenaire} from './partenaire';
import { FluxStock } from './fluxstock';
import { Reglement } from './reglement';
import { plainToClass } from 'class-transformer';
import { Commande } from './commande';
import { Produit } from './produit';
import { Bordereau } from './bordereau';
import { Taxe } from './taxe';
import { ValueTransformer } from '@angular/compiler/src/util';

export class Facture extends Data {

    date_facturation: string;
    nbr_jour_echeance: number;
    date_retour: string;
    partenaire: Partenaire;
    resp: Partenaire;
    type_facture: string;
    fluxstock: FluxStock[];
    fluxstockretour: FluxStock[];
    commandes: Commande[];
    reglements: Reglement[];
    ref: string;
    refgene: string;
    note: Text;
    livrer: boolean;
    payer: boolean;
    valider: boolean;
    bordereaux_livraison: Bordereau[];
    bordereaux_retour: Bordereau[];
    date_validation: string;
    taxes: Taxe[];

    nom_facturation: string;
    tel_facturation: string;
    pays_facturation: string;
    ville_facturation: string;
    adresse_facturation: string;
    bp_facturation: string;

    repeat: boolean;
    repeat_period: string;
    repeat_date: string;


    constructor() {
        super(); // on appelle le constructeur du parent;
        this.livrer = true;
        this.nbr_jour_echeance = 2;
        this.valider = false;
        this.payer = false;
        this.repeat = false;
    }

    get formatDatefac(): string {

      if (this.date_facturation !== null)
      return  this.formatDate(this.date_facturation);
      else
      return '';

    }

    get formatDateValidation(): string {
        if (this.date_validation !== null)
        return  this.formatDate(this.date_validation);
        else
        return '';
    }

    get formatDateEcheance(): string {

        /* if (this.date_echeance !== null) {

            const dateecheance = new Date(this.date_echeance);
            const now  = new Date();

            if (now.getTime() > dateecheance.getTime() && this.montant > this.montantReglement)
                return   this.formatDate(this.date_echeance) + '<a href="#" title="Date d\'échéance atteind"><i class="fa fa-exclamation-triangle red"></i></a>';
            else
                return  this.formatDate(this.date_echeance);

        } else {

            return '';

        } */

        let resultformat = '';
        let result = '';
        if (this.date_facturation !== undefined && this.date_facturation !== null) {

            const datefac = new Date(this.date_facturation);
            const first =  datefac.getDate();
            const last = first + this.nbr_jour_echeance;

            result = ( new Date(datefac.setDate(last))).toISOString().split('T')[0];
            resultformat = this.formatDate(result);

        }

        if (result !== '') {

            const dateecheance = new Date(result);
            const now  = new Date();

            if (now.getTime() > dateecheance.getTime() && this.reste > 0)
                return   '<div style="text-align:center"><a href="#" title="Date d\'échéance atteind (' + this.formatDate(result) + ' )"><i class="fa fa-exclamation-triangle red"></i></a></div>';
                // return   this.formatDate(result) + '<a href="#" title="Date d\'échéance atteind"><i class="fa fa-exclamation-triangle red"></i></a>';
            else
                return  this.formatDate(result);

        } else {

            return '';

        }

        // return resultformat;

    }

    get formatDateRetour(): string {

        if (this.date_retour !== null)
        return  this.formatDate(this.date_retour);
        else
        return '';
    }

    get nomPartenaire(): string {


        let result = '';
        if( this.nom_facturation !== null && this.nom_facturation !== undefined)
        result += this.nom_facturation;

        if( this.adresse_facturation !== null && this.adresse_facturation !== undefined) {
            if(result === '')
            result += '<b><i class="fa fa-map-marker"></i> Adresse: </b><br>' + this.adresse_facturation + ', ' + this.ville_facturation + '-' + this.pays_facturation;
            else
            result += '<br>' + '<i class="fa fa-map-marker"></i> <b>Adresse: </b><br>' + this.adresse_facturation + ', ' + this.ville_facturation + '-' + this.pays_facturation;
        }

        if( this.tel_facturation !== null && this.tel_facturation !== undefined) {
            if(result === '')
            result += '<b><i class="fa fa-mobile"></i> Tél: </b><br>' + this.tel_facturation;
            else
            result += '<br>' + '<b><i class="fa fa-mobile"></i> Tél: </b><br>' + + this.tel_facturation;
        }

        if( result !== '')
        return result;
        else {

            if (this.partenaire !== undefined && this.partenaire !== null)
            return this.partenaire.nom;
            else
            return '';

        }


        

    }

    get nomResp(): string {

        if (this.resp !== undefined && this.resp !== null)
        return this.resp.nom;
        else
        return '';

    }

    get link(): number {
        return this.id;
    }

    get linkprint(): number {
        return this.id;
    }

    get montantFluxstock(): number {

        let total = 0;

        const classfluxstock = plainToClass(FluxStock, this.fluxstock);

        for ( let i = 0; i < classfluxstock.length; i++) {

            total += classfluxstock[i].prixTotal;

        }

        return total;

    }

    get quantiteCommande(): number {

        let total = 0;

        if ( this.commandes !== null && this.commandes !== undefined) {

            const classCommandes = plainToClass(Commande, this.commandes);

            for ( let i = 0; i < classCommandes.length; i++) {

                total += classCommandes[i].quantite;

            }


        }

        return total;

    }

    get produitsCommande(): Produit[] {

        let produits: Produit[];

        produits = [];

        if ( this.commandes !== null && this.commandes !== undefined) {

            const classCommandes = plainToClass(Commande, this.commandes);

            for ( let i = 0; i < classCommandes.length; i++) {

                const itemIndex = classCommandes.findIndex(item => item.produit.id === classCommandes[i].produit.id);
                if (itemIndex > -1)
                produits.push(classCommandes[i].produit);

            }


        }

        return produits;

    }


    cmdByProd( idproduit: number ): Commande {

        let total: Commande;

        if ( this.commandes !== null && this.commandes !== undefined) {


            for ( let i = 0; i < this.commandes.length; i++) {

                if (this.commandes[i].produit.id === idproduit)
                total = this.commandes[i];

            }


        }

        return total;

    }



    qteCmdByProd( idproduit: number ): number {

        let total = 0;

        if ( this.commandes !== null && this.commandes !== undefined) {

            const classCommandes = plainToClass(Commande, this.commandes);

            for ( let i = 0; i < classCommandes.length; i++) {

                if (classCommandes[i].produit.id === idproduit)
                total += classCommandes[i].quantite;

            }


        }

        return total;

    }

    get quantiteLivrer(): number {

        let total = 0;

        if ( this.bordereaux_livraison !== null && this.bordereaux_livraison !== undefined) {

            const classbordereaux = plainToClass(Bordereau, this.bordereaux_livraison);

            for ( let i = 0; i < classbordereaux.length; i++) {

                total += classbordereaux[i].quantiteLivrer;

            }

        }

        return total;

    }

    qteLivrerByProd( idproduit: number ): number {


        let total = 0;

        if ( this.bordereaux_livraison !== null && this.bordereaux_livraison !== undefined) {

            const classbordereaux = plainToClass(Bordereau, this.bordereaux_livraison);

            for ( let i = 0; i < classbordereaux.length; i++) {

                total += classbordereaux[i].qteLivrerByProd(idproduit);

            }

        }

        return total;


    }

    get checkStatusLivraison(): string {

        /* let result = true;

        this.commandes.forEach( elem => {
            if (elem.produit.is_stockable && elem.produit.nature === 'article' && this.qteLivrerByProd(elem.produit.id) < elem.quantite)
            result = false;
        });

        let status = '';
        if (result)
        status = '<span class="green">  Ok <i class="fa fa-thumbs-up" aria-hidden="true"></i></span>';
        else
        status =  '<span class="red"> En attente </span>'; */

        if (this.valider === false)
        return '';

        let status = '';
        if (this.livrer)
        status = '<span class="green"> Livrée </span>';
        else
        status =  '<span class="red"> Non Livrée </span>';

        return status;

    }

    get quantiteRetour(): number {

        let total = 0;

        if ( this.bordereaux_retour !== null && this.bordereaux_retour !== undefined) {

            const classbordereaux = plainToClass(Bordereau, this.bordereaux_retour);

            for ( let i = 0; i < classbordereaux.length; i++) {

                total += classbordereaux[i].quantiteLivrer;

            }

        }

        return total;

    }

    qteRetourByProd( idproduit: number ): number {

        let total = 0;

        if ( this.bordereaux_retour !== null && this.bordereaux_retour !== undefined) {

            const classbordereaux = plainToClass(Bordereau, this.bordereaux_retour);

            for ( let i = 0; i < classbordereaux.length; i++) {

                total += classbordereaux[i].qteLivrerByProd(idproduit);

            }

        }

        return total;

    }

    get montantHTFluxstock(): number {

        let total = 0;

        let flux: FluxStock[];

        flux = [];

        if ( this.bordereaux_livraison !== undefined && this.bordereaux_livraison !== null) {

            for ( let i = 0; i < this.bordereaux_livraison.length; i++) {

                for ( let i2 = 0; i2 < this.bordereaux_livraison[i].fluxstock.length; i2++) {
                    flux.push(this.bordereaux_livraison[i].fluxstock[i2]);
                }

            }
        }


        const classfluxstock = plainToClass(FluxStock, flux);

        for ( let i = 0; i < classfluxstock.length; i++) {

            total += classfluxstock[i].prixHT;

        }

        return total;

    }

    get montantHT(): number {

        let total = 0;

        if (this.commandes !== undefined) {

            const classCommandes = plainToClass(Commande, this.commandes);

            for ( let i = 0; i < classCommandes.length; i++) {

                total += classCommandes[i].prixHT;

            }

        }

        return total;

    }



    get montantHTLivrer(): number {

        let flux: FluxStock[];

        flux = [];
        if ( this.bordereaux_livraison !== undefined && this.bordereaux_livraison !== null) {
            for ( let i = 0; i < this.bordereaux_livraison.length; i++) {

                for ( let i2 = 0; i2 < this.bordereaux_livraison[i].fluxstock.length; i2++) {
                    flux.push(this.bordereaux_livraison[i].fluxstock[i2]);
                }

            }
        }

        let total = 0;

        const classfluxstock = plainToClass(FluxStock, flux);

        for ( let i = 0; i < classfluxstock.length; i++) {

            total += classfluxstock[i].prixHT;

        }


        return total;

    }

    get montantRetour(): number {

        let flux: FluxStock[];

        flux = [];

        if (this.bordereaux_retour !== undefined && this.bordereaux_retour.length !== null) {

            for ( let i = 0; i < this.bordereaux_retour.length; i++) {

                for ( let i2 = 0; i2 < this.bordereaux_retour[i].fluxstock.length; i2++) {
                    flux.push(this.bordereaux_retour[i].fluxstock[i2]);
                }

            }

        }

        let total = 0;


        const classfluxstock = plainToClass(FluxStock, flux);

        for ( let i = 0; i < classfluxstock.length; i++) {

            total += classfluxstock[i].prixTotal;

        }

        return total;

    }

    get montantReglement(): number {

        let paye = 0;

        if (this.reglements !== undefined ) {

            const classreglement = plainToClass(Reglement, this.reglements);

            for ( let i = 0; i < classreglement.length; i++) {

                // if (classreglement[i] !== null)
                paye += classreglement[i].montant;

            }

        }

        return paye;
    }

    get remise(): number {

        let total = 0;

        if (this.commandes !== undefined) {

            const classcommande = plainToClass(Commande, this.commandes);

            for ( let i = 0; i < classcommande.length; i++) {

                if (classcommande[i].remise !== undefined)
                total += classcommande[i].remise;

            }

        }

        return total;

    }

    get montant(): number {

        return this.montantTTC - this.montantRetour;

    }

    get montantTTC(): number {

        return this.montantSansLesRetours + this.montantTaxes
    }


    get montantSansLesRetours(): number {


        let total = 0;

        if (this.commandes !== undefined) {

            const classcommande = plainToClass(Commande, this.commandes);

            for ( let i = 0; i < classcommande.length; i++) {

                
                total += classcommande[i].prixHT + classcommande[i].montantTVA;
                

            }

        }

        return total;

    }


    get reste(): number {
        if (this.montant !== 0 && this.valider) {
            if ((this.montant - this.montantReglement) >= 0 )
            return this.montant - this.montantReglement;
            else
            return 0;
        } else
        return 0;
    }

    get statusPaiement(): string {

        let status = '';

        if (this.montant !== 0 && this.valider) {

            if (this.montant <= this.montantReglement || this.payer)
            status = '<span class="green">  Payée </span>';
            else
            status =  '<span class="red"> Non Payée </span>';
        }

        return status;

    }

    get status(): string {

        // let status = this.statusPaiement  + '/' + this.checkStatusLivraison;
        let status = this.statusPaiement
        if( status !== '')
        return status = this.statusPaiement
        //return this.statusPaiement  + '/' + this.checkStatusLivraison;
        else
        return '<span class="red"> Commande </span>';

    }

    get etatFacture(): string {

        status = '<span class="red"> Commande </span>';

        if (this.valider !== undefined && this.valider !== null) {

            if (this.valider)
            status = '<span class="green"> Validée </span>';
        }

        return status;

    }

   /*  get statusLivraison(): string {

        status = '';

        if (this.montant !== 0 && this.valider) {

            if (this.quantiteCommande === this.quantiteLivrer)
            status = '<span class="green">  Ok <i class="fa fa-thumbs-up" aria-hidden="true"></i></span>';
            else
            status =  '<span class="red"> En attente </span>';

        }

        return status;

    } */


    get montantTVA(): number {

        let total = 0;

        if (this.commandes !== undefined) {

            const classcommande = plainToClass(Commande, this.commandes);

            for ( let i = 0; i < classcommande.length; i++) {
                if(classcommande[i].produit.is_emballage)
                total += classcommande[i].montantTVA;

            }

        }

        return total;
    }

    /* get montantTVA(): number {

        let total = 0;

        if (this.commandes !== undefined) {

            const classcommandes = plainToClass(Commande, this.commandes);

            for ( let i = 0; i < classcommandes.length; i++) {

                total += classcommandes[i].montantTVA;

            }

        }


        return total;

    } */

    get qteEmballage(): number {

        let total = 0;

        for ( let i = 0; i < this.commandeEmballage.length; i++) {

            total += this.commandeEmballage[i].quantite;

        }

        return total;

    }

    get montantEmballage(): number {

        let total = 0;

        for ( let i = 0; i < this.commandeEmballage.length; i++) {

            total += this.commandeEmballage[i].prixHT;

        }

        return total;

    }

    get commandeEmballage(): Commande[] {

        let total = [];

        if (this.commandes !== undefined) {

            const classCommandes = plainToClass(Commande, this.commandes);

            for ( let i = 0; i < classCommandes.length; i++) {
                if( classCommandes[i].produit.is_emballage )
                total.push( classCommandes[i] );

            }

        }

        return total;

    }


    montantTaxe(taxe: Taxe, montantHTSansEmballage: number, montantTTCSansEmballage: number, quantiteProduit: number): number {


        if (taxe.valeur === null || taxe.valeur === undefined)
        return 0;

        if( taxe.type_calcul === 'pourcentage') {

            if (Number(taxe.is_about_h_t)) {

                return ( montantHTSansEmballage * Number(taxe.valeur)) / 100;
    
            } else {
    
                return ( montantTTCSansEmballage * Number(taxe.valeur)) / 100;
            }

        } else {

            return quantiteProduit * Number(taxe.valeur);
        }

        

        // return 10;

    }

    get montantTaxes() {
    
        let total = 0;

        if (this.taxes !== undefined && this.taxes !== null) {

            const classTaxes = plainToClass(Taxe, this.taxes);

            for ( let i = 0; i < classTaxes.length; i++) {

                total += this.montantTaxe(classTaxes[i], this.montantHT - this.montantEmballage, this.montantSansLesRetours - this.montantEmballage, this.quantiteCommande);

            }
        
        }

        return total;
    }


}
